// @flow
import * as types from "../constants/action-types";
import * as modals from "../constants/modals";
import initialState from "./initial-state";
import * as R from "ramda";


export const modalsReducer = R.cond([
    [
        (state, action) => (action.type === types.TOGGLE_MODAL),
        (state, action) => {
            const modalId = action.payload.data;
            const modalIsOpen = state.data[modalId];
            return {
                ...state,
                data: { ...state.data, [modalId]: !modalIsOpen },
                error: null
            };
        }
    ],
    [
        (state, action) => (action.type === types.OPEN_MODAL),
        (state, action) => ({
            ...state,
            data: { ...state.data, [action.payload.data]: true },
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.CLOSE_MODAL),
        (state, action) => ({
            ...state,
            data: { ...state.data, [action.payload.data]: false },
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.CLOSE_ALL_MODALS),
        (state) => ({
            ...state,
            data: R.map(R.F)(modals),
            error: null
        })
    ],
    [
        (state, action) => (action.type === types.OPEN_MODAL_EXCLUSIVE),
        (state, action) => ({
            ...state,

            data: {
                ...R.map(R.F)(modals),
                [action.payload.data.modalId]: true
            },
            error: null
        })
    ],
    [
        R.T,
        state => (state || initialState.modals)
    ]
]);